export default "__VITE_ASSET__Bdc0Be5H__"